<template>
    <div class="Footer-container">
        <div class="Footer">
            <div class="viewCount">
                <span> 今日访问量: {{todayViewCount}}</span><span style="margin-left: 25px">当月访问量: {{monthViewCount}}</span>
            </div>
            <p>Copyright © 2019-2021 www.bountech.com All Rights Reserved 苏州保泰信息科技有限公司版权所有
                <a class="beianhao" target="_blank" href="https://beian.miit.gov.cn" style="text-decoration: none; color: #fff;">苏ICP备20021674号</a></p>
            <p>公司地址：苏州市朱家湾街8号3幢1203室</p>
            <p> 联系电话：0512-65929315</p>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

    export default {
        name: 'Footer',
        computed: {
            ...mapState({
                todayViewCount: state => state.todayViewCount,
                monthViewCount: state => state.monthViewCount,
            }),
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" type="text/less">
    .Footer-container {
        width: 100%;
        background-color: #222733;
        margin-top: -2px;

        .Footer {
            width: 1200px;
            margin: 0 auto;
            padding: 23px 0 18px;
            p {
                color: #fff;
                text-align: center;
                font-size: 16px;
                line-height: 28px;
                height: 28px;
            }
            .beianhao:hover {
                color: #4196ff!important;
            }
            .viewCount {
                text-align: center;
                color: #ffffff;
            }
        }
    }
</style>
